import React, { useCallback, useEffect, } from "react"
import { useDispatch, useSelector } from "react-redux";
import { adminSettingsList } from "../../Pages/AdminSettings/AdminSettingsList";
import { Box, Grid } from "@mui/material";
import { Tabs, Button, Card, InputNumber, Spin,message } from "antd";
import VizHeader from "../VizHeader/VizHeader"
import { Divider, Input, Flex } from "antd";
import Select from 'react-select';
import { updateCurationRoutingLevels, getRoutingLevelsAdmin, updateAdminGroupInfo, getGroupInfoAdmin, updateCurationPoint, getCurationRoutingAdminValuesByGroups } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import { convertMinutesToDaysHoursMinutes, settingListAdmin } from '../../utils';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Checkbox } from 'antd';
import VizParagraph from "../VizParagraph/VizParagraph";
import SettingsIcon from '@mui/icons-material/Settings';
import {components} from "react-select";
import VizButton from "../VizButtons/VizButton";
import { RECENT_RATINGS } from "../../API/url";
import AgenticSettingComponent from "../AgenticSettingComponent";




export default function GlobalSettingsBox2() {
	const dispatch = useDispatch()
	const { isLoadingAdminData,updateTabIndexKeyExpertsAssigned,updateTabIndexKeyReroutingInterval,updateTabIndexForAbortPeriod, getCurationGroupValueAdmin, adminSettingsGroupInfo, adminSettingsRoutingLevels, toggleSettingsBox } = bindActionCreators(Actions, dispatch)
	const adminSettingReducer = useSelector((state) => state.adminSettings);
	const [countryPeriod, setCountryPeriod] = React.useState(0)
	const [reroutingPeriod, setReroutingPeriod] = React.useState([])
	const [reroutingPeriodRegion, setReroutingPeriodRegion] = React.useState([])
	const [reroutingPeriodGlobal, setReroutingPeriodGlobal] = React.useState([])
	const [countryPeriodHours, setCountryPeriodHours] = React.useState(0)
	const [countryPeriodMinutes, setCountryPeriodMinutes] = React.useState(0);
	const [abortPeriodCountry, setAbortPeriodCountry] = React.useState([])
	const [abortPeriodRegion, setAbortPeriodRegion] = React.useState([])
	const [abortPeriodGlobal, setAbortPeriodGlobal] = React.useState([])
	const [initialInputValues, setInitialInputValues] = React.useState({
		reroutingIntervalCountryDays: '',
		reroutingIntervalCountryHours: '',
		reroutingIntervalCountryMinutes: ''
	})
	const [maxAcceptanceSLA, setMaxAcceptanceSLA] = React.useState([])
	const [updatedArrayRecordsRoutingIntervals, setUpdatedArrayRecordsRoutingIntervals] = React.useState(adminSettingReducer?.routingLevelsData)
	const [updatedArrayRecordsGroupInfo, setUpdatedArrayRecordsGroupInfo] = React.useState(adminSettingReducer?.groupInfoData)



	const successToastMessage = (data) => {
		return (
			<span style={{ fontSize: '12px' }}>{data}</span>
		)
	}

	const showMessage = (param) => {
		message.info(param)
	}

	function convertMinutesToDay(minutes) {
		let days = Math.floor(minutes / (24 * 60));
		let hours = Math.floor((minutes % (24 * 60)) / 60);
		let remainingMinutes = Math.floor(minutes % 60);
		return `${days},${hours},${remainingMinutes}`;
	}
	useEffect(() => {
		// setTabIndexKey(localStorage.getItem('tabKeyRerouting'))
		setUpdatedArrayRecordsRoutingIntervals(adminSettingReducer?.routingLevelsData)
		setUpdatedArrayRecordsGroupInfo(adminSettingReducer?.groupInfoData)
		setReroutingPeriod([])
		setMaxAcceptanceSLA([])
		setAbortPeriodCountry([])
		// let arr2 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[0]?.timeoutPeriod).split(',').map(Number)
		// let arr3 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[1]?.timeoutPeriod).split(',').map(Number)
		// let arr4 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[2]?.timeoutPeriod).split(',').map(Number)
		// let arr5 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[0]?.abortPeriod).split(',').map(Number)
		// let arr6 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[1]?.abortPeriod).split(',').map(Number)
		// let arr7 = convertMinutesToDay(adminSettingReducer?.routingLevelsData[2]?.abortPeriod).split(',').map(Number)
		// let arr8 = convertMinutesToDay(adminSettingReducer?.groupInfoData[0].maxSla).split(',').map(Number)
        let arr2 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[0]?.timeoutPeriod).split(',').map(Number)
		let arr3 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[1]?.timeoutPeriod).split(',').map(Number)
		let arr4 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[2]?.timeoutPeriod).split(',').map(Number)
		let arr5 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[0]?.abortPeriod).split(',').map(Number)
		let arr6 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[1]?.abortPeriod).split(',').map(Number)
		let arr7 = convertMinutesToDay(updatedArrayRecordsRoutingIntervals[2]?.abortPeriod).split(',').map(Number)
		let arr8 = convertMinutesToDay(updatedArrayRecordsGroupInfo[0].maxSla).split(',').map(Number)
		setReroutingPeriod(arr2)
		setReroutingPeriodRegion(arr3)
		setReroutingPeriodGlobal(arr4)
		setAbortPeriodCountry(arr5)
		setAbortPeriodRegion(arr6)
		setAbortPeriodGlobal(arr7)
		setMaxAcceptanceSLA(arr8)
        // console.log(arr2,'check check check check')
		// return() => {
		// 	// toggleSettingsBox(0)
		// 	localStorage.setItem('tabKeyRerouting','reroutingCountryInterval')
		// }	
		// return () => {
		// }
			// setTabIndexKey(localStorage.getItem('tabKeyRerouting'))
	
	}, [adminSettingReducer?.routingLevelsData, adminSettingReducer?.groupInfoData,adminSettingReducer?.curationRoutingValueByGroup])
	// }, [updatedArrayRecordsRoutingIntervals, updatedArrayRecordsGroupInfo, adminSettingReducer?.curationRoutingValueByGroup])


	const onClickBackButton = () => {
		toggleSettingsBox(0)
		// localStorage.removeItem('tabKeyRerouting')
		// localStorage.removeItem('tabKeyAbortPeriod')
		// localStorage.removeItem('tabKeyForExpertsAssigned')
		localStorage.setItem('tabKeyRerouting','reroutingIntervalCountryDays')
		localStorage.setItem('tabKeyAbortPeriod','abortPeriodCountry')
		localStorage.setItem('tabKeyForExpertsAssigned','expertsAssignedCountry')
	}

	const onChangeAdd = () => {
		if (countryPeriod < 365) {
			setCountryPeriod((prevCount) => parseInt(prevCount += 1))
		}
	}

	const onChange = (key) => {
		if (key > 365) {
			setCountryPeriod(parseInt(365))
		}
		if (key >= 0 && key <= 365) {
			setCountryPeriod(parseInt(key))
		}
		if (key < 0 || key === 0 || key === '') {
			setCountryPeriod(parseInt(0))
		}
		if (key === 0) {
			setCountryPeriod(0)
		}
	};


	const onChangeNumberOfExperts = (val) => {
		// console.log(val, 'check val')
	}

	// const handleChange2 = (val) => {
	// 	setReroutingCountry(val)
	// 	console.log(val,'check val')
	// }

	const noOfExpertItems = [
		{
			key: '1',
			label: <VizHeader type={5}>Country</VizHeader>,
			children:
				<>
					<div style={{ display: 'flex', gap: '12px', marginTop: '5px' }}>
						<div>
							<Input type="number" onChange={(e) => onChangeNumberOfExperts(e.target.value)} addonAfter={"Experts"} defaultValue={adminSettingReducer?.routingLevelsData[0]?.maxExpert} />
						</div>
					</div>
				</>
		},
		{
			key: '2',
			label: <VizHeader type={5}>Region</VizHeader>,
			children:
				<>
					<div style={{ display: 'flex', gap: '12px', marginTop: '5px' }}>
						<div >
							<Input type="number" addonAfter={"Experts"} defaultValue={adminSettingReducer?.routingLevelsData[1].maxExpert} />
						</div>
					</div>
				</>
		},
		{
			key: '3',
			label: <VizHeader type={5}>Global</VizHeader>,
			children:
				<>
					<div style={{ display: 'flex', gap: '12px', marginTop: '5px' }}>
						<div>
							<Input type="number" addonAfter={"Experts"} defaultValue={adminSettingReducer?.routingLevelsData[2].maxExpert} />
						</div>
					</div>
				</>
		}
	]

	const SettingsListBox = (props) => {
		const InputComponent = ({ data }) => {
			const [userRankingVal, setUserRankingVal] = React.useState(updatedArrayRecordsGroupInfo[0].userRankingsEnabled === true ? true : false)
			const [textSummarizationVal, setTextSummarizationVal] = React.useState(updatedArrayRecordsGroupInfo[0].textSummarizationEnabled === true ? true : false)
			const [searchCountEmailRecordsVal, setSearchCountEmailRecordsVal] = React.useState(updatedArrayRecordsGroupInfo[0].searchCountEmailRecords)
			const [searchCountDocRecordsVal, setSearchCountDocRecordsVal] = React.useState(updatedArrayRecordsGroupInfo[0].searchCountDocRecords)
			const [searchCountExpertRecordsVal, setSearchCountExpertRecordsVal] = React.useState(updatedArrayRecordsGroupInfo[0].searchCountExpertRecords)
			const [autoSuggestCountRecordsVal, setAutoSuggestCountRecordsVal] = React.useState(updatedArrayRecordsGroupInfo[0].autoSuggestCount)
			const [timeoutPeriodUrgentVal, setTimeoutPeriodUrgentVal] = React.useState(updatedArrayRecordsGroupInfo[0].timeoutPeriodUrgent)
			const [unansweredQuestionsDaysVal, setUnansweredQuestionsDaysVal] = React.useState(updatedArrayRecordsGroupInfo[0].unansweredQuestionsDays === undefined ? 0 : adminSettingReducer?.groupInfoData[0].unansweredQuestionsDays)
			const [declinedAnswerWindowVal, setDeclinedAnswerWindowVal] = React.useState(updatedArrayRecordsGroupInfo[0].threshold)
			const [expertCurationEvergreen, setExpertCurationEvergreen] = React.useState((updatedArrayRecordsGroupInfo[0].evergreenMonths) / 12);
			const [expertAnswerExpirationVal, setExpertAnswerExpirationVal] = React.useState(updatedArrayRecordsGroupInfo[0].expirationMonths);
			const [seekerCurationVisibilityVal, setCurationVisibilityVal] = React.useState(updatedArrayRecordsGroupInfo[0].seekerCurationVisibility === true ? true : false)
			const [userSearchesVal, setUserSearchesVal] = React.useState(updatedArrayRecordsGroupInfo[0].userOverallSearches)
			const [userKnowledgeRecordsVal, setUserKnowledgeRecordsVal] = React.useState(updatedArrayRecordsGroupInfo[0].userKnowledgeRecordsViewed)
			const [userQuestionsSubmittedVal, setUserQuestionsSubmittedVal] = React.useState(updatedArrayRecordsGroupInfo[0].userQuestionsSubmittedToExperts)
			const [userKnowledgeRecordsMinVal, setUserKnowledgeRecordsMinVal] = React.useState(updatedArrayRecordsGroupInfo[0].userKnowledgeRecordsViewedMinCount)
			const [userOverallSearchesVal, setUserOverallSearchesVal] = React.useState(updatedArrayRecordsGroupInfo[0].userOverallSearchesMinCount)
			const [userQuestionsSubmittedMinVal, setUserQuestionsSubmittedMinVal] = React.useState(updatedArrayRecordsGroupInfo[0].userQuestionsSubmittedToExpertsMinCount)
			const [overallSearchesVal, setOverallSearchesVal] = React.useState(updatedArrayRecordsGroupInfo[0].systemOverallSearches)
			const [overallKnowledgeRecordsViewedVal, setOverallKnowledgeRecordsViewedVal] = React.useState(updatedArrayRecordsGroupInfo[0].systemKnowledgeRecordsViewed)
			const [overallQuestionsAnsweredVal, setOverallQuestionsAnsweredVal] = React.useState(updatedArrayRecordsGroupInfo[0].systemQuestionsAnswered);
			const [overallLoggedIn, setOverallLoggedIn] = React.useState(updatedArrayRecordsGroupInfo[0].systemUserLogins)
			const [docScrapped, setDocScrapped] = React.useState(updatedArrayRecordsGroupInfo[0].systemDocsScraped)
			const [overallLikes, setOverallLikes] = React.useState(updatedArrayRecordsGroupInfo[0].systemLikes)
			const [keyTermViews, setKeyTermViews] = React.useState(updatedArrayRecordsGroupInfo[0].systemTrendingKeyTermsViews)
			const [overallQuestionView, setOverallQuestionView] = React.useState(updatedArrayRecordsGroupInfo[0].systemQuestionsDocViewCount);
			const [knowledgeUpdates, setKnowledgeUpdates] = React.useState(updatedArrayRecordsGroupInfo[0].systemKnowledgeUpdatesMinCount)
			const [knowledgeRecordsMinVal, setKnowledgeRecordsMinVal] = React.useState(updatedArrayRecordsGroupInfo[0].systemKnowledgeRecordsViewedMinCount)
			const [systemknowledgeUpdates, setSystemKnowledgeUpdates] = React.useState(updatedArrayRecordsGroupInfo[0].systemKnowledgeUpdates)
			const [systemLikesMinCount, setSystemLikesMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemLikesMinCount)
			const [systemOverallSearches, setSystemOverallSearches] = React.useState(updatedArrayRecordsGroupInfo[0].systemOverallSearchesMinCount)
			const [systemQuestionsMinCount, setsystemQuestionsMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemQuestionsAnsweredMinCount)
			const [systemQuestionsDocViewMinCount, setSystemQuestionsDocViewMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemQuestionsDocViewMinCount)
			const [systemTrendingKeyTermsViewsMinCount, setSystemTrendingKeyTermsViewsMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemTrendingKeyTermsViewsMinCount)
			const [systemUserLoginsMinCount, setSystemUserLoginsMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemUserLoginsMinCount)
			const [systemDocsScrapedMinCount, setSystemDocsScrapedMinCount] = React.useState(updatedArrayRecordsGroupInfo[0].systemDocsScrapedMinCount)
			const [systemResponseTime, setSystemResponseTime] = React.useState(updatedArrayRecordsGroupInfo[0].systemResponseTime)
			// const [isCountryVisible, setIsCountryVisible] = React.useState(adminSettingReducer?.curationRoutingValueByGroup[0].startPointValue !== undefined ? true : false)
			const [isCountryVisible, setIsCountryVisible] = React.useState(false)
			const [curationRoutingValues, setCurationRoutingValuesOptions] = React.useState([{ label: 'Country', value: 'Country', startPointValue: 1 }, { label: 'Region', value: 'Region', startPointValue: 2 }, { label: 'Global', value: 'Global', startPointValue: 3 }]) 
			const [curationRouting, setCurationRoutingValues] = React.useState({})
			const [getMinAcceptableAnswers, setMinAcceptableAnswers] = React.useState(updatedArrayRecordsGroupInfo[0].minAcceptableAnswer)
			const [curationMethod, setCurationMethod] = React.useState(adminSettingReducer?.curationRoutingValueByGroup.length > 0 ? adminSettingReducer?.curationRoutingValueByGroup : []);
			const [reroutingCountryDays, setReroutingCountryDays] = React.useState(reroutingPeriod[0]);
			const [rereoutingCountryHours, setReroutingCountryHours] = React.useState(reroutingPeriod[1]);
			const [rereoutingCountryMinutes, setReroutingCountryMinutes] = React.useState(reroutingPeriod[2]);
			const [reroutingCountryDaysRegion, setReroutingCountryDaysRegion] = React.useState(reroutingPeriodRegion[0]);
			const [reroutingCountryHoursRegion, setReroutingCountryHoursRegion] = React.useState(reroutingPeriodRegion[1]);
			const [reroutingCountryMinutesRegion, setReroutingCountryMinutesRegion] = React.useState(reroutingPeriodRegion[2]);
			const [reroutingDaysGlobal, setReroutingDaysGlobal] = React.useState(reroutingPeriodGlobal[0]);
			const [reroutingHoursGlobal, setReroutingHoursGlobal] = React.useState(reroutingPeriodGlobal[1]);
			const [reroutingGlobalMinutes, setReroutingGlobalMinutes] = React.useState(reroutingPeriodGlobal[2]);
			const [tabIndexKey, setTabIndexKey] = React.useState('reroutingIntervalCountryDays');
			const memoizedActiveKeyReRouting = React.useMemo(() => tabIndexKey, [tabIndexKey]);
			const [abortPeriodCountryDays, setAbortPeriodCountryDays] = React.useState(abortPeriodCountry[0])
			const [abortPeriodCountryHours, setAbortPeriodCountryHours] = React.useState(abortPeriodCountry[1])
			const [abortPeriodCountryMinutes, setAbortPeriodCountryMinutes] = React.useState(abortPeriodCountry[2])
			const [abortPeriodRegionDays, setAbortPeriodRegionDays] = React.useState(abortPeriodRegion[0])
			const [abortPeriodRegionHours, setAbortPeriodRegionHours] = React.useState(abortPeriodRegion[1])
			const [abortPeriodRegionMinutes, setAbortPeriodRegionMinutes] = React.useState(abortPeriodRegion[2])
			const [abortPeriodGlobalDays, setAbortPeriodGlobalDays] = React.useState(abortPeriodGlobal[0])
			const [abortPeriodGlobalHours, setAbortPeriodGlobalHours] = React.useState(abortPeriodGlobal[1])
			const [abortPeriodGlobalMinutes, setAbortPeriodGlobalMinutes] = React.useState(abortPeriodGlobal[2])
			/* state for change of tabs in abort period */
			const [tabIndexKeyAbortPeriod, setTabIndexKeyAbortPeriod] = React.useState("abortPeriodCountry")
			const [tabIndexKeyExpertsAssigned, setTabIndexKeyExpertsAssigned] = React.useState('expertsAssignedCountry')
			const [noOfExpertsCountry, setNoOfExpertsCountry] = React.useState(updatedArrayRecordsRoutingIntervals[0].maxExpert)
			const [noOfExpertsRegion, setNoOfExpertsRegion] = React.useState(updatedArrayRecordsRoutingIntervals[1].maxExpert)
			const [noOfExpertsGlobal, setNoOfExpertsGlobal] = React.useState(updatedArrayRecordsRoutingIntervals[2].maxExpert)
			const [maxSlaDays, setMaxSlaDays] = React.useState(maxAcceptanceSLA[0]);
			const [maxSlaHours, setMaxSlaHours] = React.useState(maxAcceptanceSLA[1]);
			const [maxSlaMinutes, setMaxSlaMinutes] = React.useState(maxAcceptanceSLA[2]);
			const [isCountryDropdownVisible, setIsCountryDropdownVisible] = React.useState(adminSettingReducer?.curationRoutingValueByGroup[0]?.visibility === undefined ? false :adminSettingReducer?.curationRoutingValueByGroup[0]?.visibility )
			const [countryDropdownDefaultValue, setCountryDropdownDefaultValue] = React.useState(adminSettingReducer?.curationRoutingValueByGroup)
			const MAX_VALUE = 2147483647;
			const errorMessage = {
				greaterThanZero : 'Value should be greater than 0.',
				greaterThanOrEqualToZero: 'Value should be greater than or equal to 0.',
				greaterThanLimit:`Value should be in between 0 and ${MAX_VALUE}.`
			}
			const inputNumberRef = React.useRef(null);
	
			const customStyles = {
				// menu: (provided) => ({
				//   ...provided,
				//   zIndex: 9999,
				// }),
	
				control: (base) => ({
					...base,
					height: 29,
					minHeight: 29,
					marginBottom: 5,
					borderColor: "lightgray",
					fontSize: '12px'
					// width:'120px',
					// zIndex:9999
				}),
				menu: (styles) => ({
					...styles,
					zIndex: 1200,
					fontSize: '12px'
				}),
				dropdownIndicator: (styles) => ({
					...styles,
					paddingTop: 0,
					paddingBottom: 0,
					color: "lightgray",
				}),
				clearIndicator: (styles) => ({
					...styles,
					paddingTop: 0,
					paddingBottom: 0,
					color: "lightgray",
				}),
				// option: (baseStyles, state) => ({
				// 	...baseStyles,
				// 	backgroundColor: state.isFocused
				// 		? "var(--light_color_shade)"
				// 		: state.isSelected
				// 		? "var(--light_color_shade)"
				// 		: "none",
				// 	color: state.isDisabled
				// 		? state.isFocused || state.isSelected
				// 			? "#fff"
				// 			: "none"
				// 		: state.isFocused || state.isSelected
				// 		? "#fff"
				// 		: "black",
				// }),
				option: (provided, state) => ({
					...provided,
					backgroundColor: (state.isFocused ? 'var(--light_color_shade)' : 'white'),
					color: state.isFocused ? 'white' : 'black',
					padding: 10,
					cursor: 'pointer'
				}
				),
			};

            const handleOnWeel = (e) => {
                e.target.addEventListener("wheel", function (e) {e.preventDefault()}, {passive: false })
            }
	
		
			const items = [
				{
					key: 'reroutingIntervalCountryDays',
					label: <VizHeader type={5}>Country</VizHeader>,
					children:
						<>
							<Grid container padding={1} columnGap={2}>
								<Grid item lg={2}>
									<VizHeader type={6}>Days:</VizHeader>
									{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
									<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays} min={0} max={365} defaultValue={reroutingPeriod[0]}
                                    onFocus = {(e)=>handleOnWeel(e)} />
								</Grid>
								<Grid item lg={2}>
									<VizHeader type={6}>Hours:</VizHeader>
									{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
									<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours} min={0} max={23} defaultValue={reroutingPeriod[1]}
                                    onFocus = {(e)=>handleOnWeel(e)} />
								</Grid>
								<Grid item lg={2}>
									<VizHeader type={6}>Minutes:</VizHeader>
									{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
                                    <Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={adminSettingReducer?.isLoading === false ? rereoutingCountryMinutes : 0} min={0} max={59} defaultValue={reroutingPeriod[2]} ref={inputNumberRef} onFocus = {(e)=>handleOnWeel(e)}/>
								</Grid>
								<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
									<div>
										{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									 <VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
									</div>
								</Grid>
							</Grid>
						</>
					,
				},
				{
					key: 'reroutingIntervalRegion',
					label: <VizHeader type={5}>Region</VizHeader>,
					children:
						<Grid container padding={1} columnGap={2} >
							<Grid item lg={2}>
								<VizHeader type={6}>Days:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalRegionDays")} value={reroutingCountryDaysRegion} min={0} max={365} defaultValue={reroutingPeriodRegion[0]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Hours:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalRegionHours")} value={reroutingCountryHoursRegion} min={0} max={23} defaultValue={reroutingPeriodRegion[1]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Minutes:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalRegionMinutes")} value={reroutingCountryMinutesRegion} min={0} max={59} defaultValue={reroutingPeriodRegion[2]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
								<div>
									{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
								</div>
							</Grid>
						</Grid>
				},
				{
					key: 'reroutingIntervalGlobal',
					label: <VizHeader type={5}>Global</VizHeader>,
					children:
						<Grid container padding={1} columnGap={2}>
							<Grid item lg={2}>
								<VizHeader type={6}>Days:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalGlobalDays")} value={reroutingDaysGlobal} min={0} max={365} defaultValue={reroutingPeriodGlobal[0]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Hours:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalGlobalHours")} value={reroutingHoursGlobal} min={0} max={23} defaultValue={reroutingPeriodGlobal[1]} 
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Minutes:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "reroutingIntervalGlobalMinutes")} value={reroutingGlobalMinutes} min={0} max={59} defaultValue={reroutingPeriodGlobal[2]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
								<div>
									{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
								</div>
							</Grid>
						</Grid>
				},
			];
			const expertsAssignedItems = [
				{
					key: 'expertsAssignedCountry',
					label: <VizHeader type={5}>Country</VizHeader>,
					children:
						<>
							<Grid container padding={1} columnGap={2}>
								<Grid item lg={7}>
									{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
									<Input addonAfter="Experts" type="number" onChange={(e) => onChangeCheckbox(e, "noOfExpertsCountry")} value={noOfExpertsCountry} min={0} max={2147483647}
                                    onFocus = {(e)=>handleOnWeel(e)}  />
								</Grid>
								<Grid item lg={2} textAlign="center">
									{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
								</Grid>
							</Grid>
						</>
					,
				},
				{
					key: 'expertsAssignedRegion',
					label: <VizHeader type={5}>Region</VizHeader>,
					children:
						<Grid container padding={1} columnGap={2}>
							<Grid item lg={7}>
								{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
								<Input addonAfter="Experts" type="number" onChange={(e) => onChangeCheckbox(e, "noOfExpertsRegion")} value={noOfExpertsRegion} min={0} max={2147483647}
                                onFocus = {(e)=>handleOnWeel(e)}  />
							</Grid>
							<Grid item lg={2} textAlign="center">
								{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
							</Grid>
						</Grid>
				},
				{
					key: 'expertsAssignedGlobal',
					label: <VizHeader type={5}>Global</VizHeader>,
					children:
						<Grid container padding={1} columnGap={2}>
							<Grid item lg={7}>
								{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
								<Input type="number" addonAfter="Experts" onChange={(e) => onChangeCheckbox(e, "noOfExpertsGlobal")} value={noOfExpertsGlobal} min={0} max={2147483647} onFocus = {(e)=>handleOnWeel(e)}  />
							</Grid>
							<Grid item lg={2} textAlign="center">
								{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
										Update
									</VizButton>
							</Grid>
						</Grid>
				},
			]
	
			const handleBlur = () => {
				if (abortPeriodRegionDays === 0) {
					setAbortPeriodRegionDays(0);
				}
			};
	
			const itemsAbortPeriod = [{
				key: 'abortPeriodCountry',
				label: <VizHeader type={5}>Country</VizHeader>,
				children:
					<>
						<Grid container padding={1} columnGap={2}>
							<Grid item lg={2}>
								<VizHeader type={6}>Days:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodCountryDays")} value={abortPeriodCountryDays} min={0} max={365} defaultValue={abortPeriodCountry[0]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Hours:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodCountryHours")} value={abortPeriodCountryHours} min={0} max={23} defaultValue={abortPeriodCountry[1]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2}>
								<VizHeader type={6}>Minutes:</VizHeader>
								{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
								<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodCountryMinutes")} value={abortPeriodCountryMinutes} min={0} max={59} defaultValue={abortPeriodCountry[2]}
                                onFocus = {(e)=>handleOnWeel(e)} />
							</Grid>
							<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
								<div>
									{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
									Update
									</VizButton>
								</div>
							</Grid>
						</Grid>
					</>
				,
			},
			{
				key: 'abortPeriodRegion',
				label: <VizHeader type={5}>Region</VizHeader>,
				children:
					<Grid container padding={1} columnGap={2}>
						<Grid item lg={2}>
							<VizHeader type={6}>Days:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
							<Input maxLength={400}  type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodRegionDays")} value={abortPeriodRegionDays} min={0} max={365} defaultValue={abortPeriodRegion[0]}
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2}>
							<VizHeader type={6}>Hours:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
							<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodRegionHours")} value={abortPeriodRegionHours} min={0} max={23} defaultValue={abortPeriodRegion[1]} 
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2}>
							<VizHeader type={6}>Minutes:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
							<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodRegionMinutes")} value={abortPeriodRegionMinutes} min={0} max={59} defaultValue={abortPeriodRegion[2]}
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
							<div>
								{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
									Update
									</VizButton>
							</div>
						</Grid>
					</Grid>
			},
			{
				key: 'abortPeriodGlobal',
				label: <VizHeader type={5}>Global</VizHeader>,
				children:
					<Grid container padding={1} columnGap={2}>
						<Grid item lg={2}>
							<VizHeader type={6}>Days:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[0]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} min={0} max={365} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryDays")} value={reroutingCountryDays}></input> */}
							<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodGlobalDays")} value={abortPeriodGlobalDays} min={0} max={365} defaultValue={abortPeriodGlobal[0]}
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2}>
							<VizHeader type={6}>Hours:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[1]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={23} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryHours")} value={rereoutingCountryHours}></input> */}
							<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodGlobalHours")} value={abortPeriodGlobalHours} min={0} max={23} defaultValue={abortPeriodGlobal[1]}
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2}>
							<VizHeader type={6}>Minutes:</VizHeader>
							{/* <input defaultValue={reroutingPeriod[2]} type={"number"} style={{ border: '1px solid lightgrey', height: '32px', width: '30%' }} max={59} onChange={(e) => onChangeCheckbox(e, "reroutingIntervalCountryMinutes")} value={rereoutingCountryMinutes} ></input> */}
							<Input type="number" onChange={(e) => onChangeCheckbox(e, "abortPeriodGlobalMinutes")} value={abortPeriodGlobalMinutes} min={0} max={59} defaultValue={abortPeriodGlobal[2]}
                            onFocus = {(e)=>handleOnWeel(e)} />
						</Grid>
						<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', paddingTop: '12px' }}>
							<div>
								{/* <Button onClick={(data, id) => onClickUpdate(data, id)} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
									Update
								</VizButton>
							</div>
						</Grid>
					</Grid>,
			}]
	
			const onChangeTabsForReRouting = (val)=>{
				// updateTabIndexKeyReroutingInterval(val)
				let tabIndexKey =localStorage.setItem("tabKeyRerouting",val)
				setTabIndexKey(localStorage.getItem('tabKeyRerouting'))
			}
		
			const onChangeTabsForAbortPeriod = (val)=>{
				// updateTabIndexForAbortPeriod(val)
				localStorage.setItem("tabKeyAbortPeriod",val)
				setTabIndexKeyAbortPeriod(localStorage.getItem("tabKeyAbortPeriod"))
			}
		
			const onChangeTabsForExpertsAssigned = (val)=>{
				localStorage.setItem("tabKeyForExpertsAssigned",val)
				// updateTabIndexKeyExpertsAssigned(val)
				setTabIndexKeyExpertsAssigned(localStorage.getItem("tabKeyForExpertsAssigned"))
			}
	
			useEffect(() => {
				if (localStorage.getItem('tabKeyRerouting') !== undefined) {
					setTabIndexKey(localStorage.getItem('tabKeyRerouting'))
				}
				if (localStorage.getItem('tabKeyAbortPeriod') !== undefined) {
					setTabIndexKeyAbortPeriod(localStorage.getItem('tabKeyAbortPeriod'))
				}
				if (localStorage.getItem('tabKeyForExpertsAssigned') !== undefined) {
					setTabIndexKeyExpertsAssigned(localStorage.getItem('tabKeyForExpertsAssigned'))
				}
			}, [])
			const onChangeCheckbox =useCallback((e, id) => {
				if (data === 'User Ranking') {
					if (e.target.checked) {
						setUserRankingVal(true)
					}
					else {
						setUserRankingVal(false)
					}
				}
				if (data === 'Text Summarization') {
					if (e.target.checked) {
						setTextSummarizationVal(true)
					}
					else {
						setTextSummarizationVal(false)
					}
				}
				if (data === 'Search Count Email Records') {
					// setSearchCountEmailRecordsVal('')
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setSearchCountEmailRecordsVal(roundedValue)
						}
						else {
							setSearchCountEmailRecordsVal('')
						}
					}
					else {
						setSearchCountEmailRecordsVal(e.target.value)
					}
				}
				if (data === 'Search Count Doc Records') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setSearchCountDocRecordsVal(roundedValue)
						}
						else {
							setSearchCountDocRecordsVal('')
						}
					}
					else {
						setSearchCountDocRecordsVal(e.target.value)
					}
				}
				if (data === 'Search Count Expert Records') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setSearchCountExpertRecordsVal(roundedValue)
						}
						else {
							setSearchCountExpertRecordsVal('')
						}
					}
					else {
						setSearchCountExpertRecordsVal(e.target.value)
					}
				}
				if (data === 'Auto Suggest Count Expert Records') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setAutoSuggestCountRecordsVal(roundedValue)
						}
						else {
							setAutoSuggestCountRecordsVal('')
						}
					}
					else {
						setAutoSuggestCountRecordsVal(e.target.value)
					}
				}
				if (data === 'Urgent Question Timeout Period') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setTimeoutPeriodUrgentVal(roundedValue)
						}
						else {
							setTimeoutPeriodUrgentVal('')
						}
					}
					else {
						setTimeoutPeriodUrgentVal(e.target.value)
					}
				}
				if (data === 'Unanswered Question Timeout Period') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setUnansweredQuestionsDaysVal(roundedValue)
						}
						else
						{
							setUnansweredQuestionsDaysVal('')
						}
					}
					else {
						setUnansweredQuestionsDaysVal(e.target.value)
					}
				}
				if (data === 'Declined Answer Window') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setDeclinedAnswerWindowVal(roundedValue)
						}
						else {
							setDeclinedAnswerWindowVal('')
						}
					}
					else {
						setDeclinedAnswerWindowVal(e.target.value)
					}
				}
				if (data === 'Expert Curation Evergreen Window') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setExpertCurationEvergreen(roundedValue)
						}
						else {
							setExpertCurationEvergreen("")
						}
					}
					// else {
					// 	setExpertCurationEvergreen(e.target.value)
					// }
				}
				if (data === 'Expert Answer Expiration') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setExpertAnswerExpirationVal(roundedValue)
						}
						else {
							setExpertAnswerExpirationVal('')
						}
					}
					else {
						setExpertAnswerExpirationVal(e.target.value)
					}
				}
				if (data === 'Seeker Curation Visiblity') {
					if (e.target.checked) {
						setCurationVisibilityVal(true)
					}
					else {
						setCurationVisibilityVal(false)
					}
				}
				if (data === 'User Searches') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setUserSearchesVal(roundedValue)
						}
						else 
						{
							setUserSearchesVal('')
						}
					}
					else {
						setUserSearchesVal(e.target.value)
					}
				}
	
				if (data === 'User Knowledge Records Viewed') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setUserKnowledgeRecordsVal(roundedValue)
						}
						else 
						{
							setUserKnowledgeRecordsVal('')
						}
					}
					else {
						setUserKnowledgeRecordsVal(e.target.value)
					}
				}
				if (data === 'User Question Submitted') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setUserQuestionsSubmittedVal(roundedValue)
						}
						else {
							setUserQuestionsSubmittedVal('')
						}
					}
					else {
						setUserQuestionsSubmittedVal(e.target.value)
					}
				}
				if (data === 'User Knowledge Records Viewed MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setUserKnowledgeRecordsMinVal(roundedValue)
						}
						else {
							setUserKnowledgeRecordsMinVal('')
						}
					}
					else {
						setUserKnowledgeRecordsMinVal(e.target.value)
					}
				}
				if (data === 'User Overall Searches MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setUserOverallSearchesVal(roundedValue)
						}
						else {
							setUserOverallSearchesVal('')
						}
					}
					else {
						setUserOverallSearchesVal(e.target.value)
					}
				}
				if (data === 'User Questions Submitted To Experts MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setUserQuestionsSubmittedMinVal(roundedValue)
						}
						else {
							setUserQuestionsSubmittedMinVal('')
						}
					}
					else {
						setUserQuestionsSubmittedMinVal(e.target.value)
					}
				}
				if (data === 'Overall Searches') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setOverallSearchesVal(roundedValue)
						}
						else {
							setOverallSearchesVal('')
						}
					}
					else {
						setOverallSearchesVal(e.target.value)
					}
				}
				if (data === 'Overall Knowledge Records Viewed') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setOverallKnowledgeRecordsViewedVal(roundedValue)
						}
						else {
							setOverallKnowledgeRecordsViewedVal('')
						}
					}
					else {
						setOverallKnowledgeRecordsViewedVal(e.target.value)
					}
				}
				if (data === 'Overall Questions Answered') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setOverallQuestionsAnsweredVal(roundedValue)}
						else 
						{
							setOverallQuestionsAnsweredVal('')
						}
					}
					else {
						setOverallQuestionsAnsweredVal(e.target.value)
					}
				}
				if (data === 'Overall LoggedIn') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setOverallLoggedIn(roundedValue)}
						else 
						{
							setOverallLoggedIn('')
						}
					}
					else {
						setOverallLoggedIn(e.target.value)
					}
				}
				if (data === 'Overall Document Scraped') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setDocScrapped(roundedValue)
						}
						else {
	
							setDocScrapped('')
						}
					}
					else {
						setDocScrapped(e.target.value)
					}
				}
				if (data === 'Overall Likes') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setOverallLikes(roundedValue)}
						else 
						{
							setOverallLikes('')
						}
					}
					else {
						setOverallLikes(e.target.value)
					}
				}
				if (data === 'Overall Key Terms') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setKeyTermViews(roundedValue)}
						else 
						{
							setKeyTermViews('')
						}
					}
					else {
						setKeyTermViews(e.target.value)
					}
				}
				if (data === 'Overall Question View') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0 )
						{
						setOverallQuestionView(roundedValue)}
						else 
						{
							setOverallQuestionView('')
						}
					}
					else {
						setOverallQuestionView(e.target.value)
					}
				}
				if (data === 'Overall Knowledge Updates') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemKnowledgeUpdates(roundedValue)}
						else 
						{
							setSystemKnowledgeUpdates('')
						}
					}
					else {
						setSystemKnowledgeUpdates(e.target.value)
					}
				}
				if (data === 'System Knowledge Records Viewed MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setKnowledgeRecordsMinVal(roundedValue)}
						else 
						{
							setKnowledgeRecordsMinVal('')
						}
					}
					else {
						setKnowledgeRecordsMinVal(e.target.value)
					}
				}
				if (data === 'System Knowledge Updates MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
							setKnowledgeUpdates(roundedValue)
						}
						else 
						{
							setKnowledgeUpdates('')
						}
					}
					else {
						setKnowledgeUpdates(e.target.value)
					}
				}
				if (data === 'System Likes MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemLikesMinCount(roundedValue)
						}
						else 
						{
							setSystemLikesMinCount('')
						}
					}
					else {
						setSystemLikesMinCount(e.target.value)
					}
				}
				if (data === 'System Overall Searches MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if (roundedValue > 0) {
							setSystemOverallSearches(roundedValue)
						}
						else {
							setSystemOverallSearches('')
						}
					}
					else {
						setSystemOverallSearches(e.target.value)
					}
				}
				if (data === 'System Questions Answered MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setsystemQuestionsMinCount(roundedValue)}
						else 
						{
							setsystemQuestionsMinCount('')
						}
					}
					else {
						setsystemQuestionsMinCount(e.target.value)
					}
				}
				if (data === 'System Questions DocView MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemQuestionsDocViewMinCount(roundedValue)
						}
						else 
						{
							setSystemQuestionsDocViewMinCount('')
						}
					}
					else {
						setSystemQuestionsDocViewMinCount(e.target.value)
					}
				}
				if (data === 'System Trending KeyTerms Views MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemTrendingKeyTermsViewsMinCount(roundedValue)}
						else 
						{
							setSystemTrendingKeyTermsViewsMinCount('')
						}
					}
					else {
						setSystemTrendingKeyTermsViewsMinCount(e.target.value)
					}
				}
				if (data === 'System User Logins MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemUserLoginsMinCount(roundedValue)}
						else 
						{
							setSystemUserLoginsMinCount('')					}
					}
					else {
						setSystemUserLoginsMinCount(e.target.value)
					}
				}
				if (data === 'System Docs Scraped MinCount') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemDocsScrapedMinCount(roundedValue)}
						else 
						{
							setSystemDocsScrapedMinCount('')
						}
					}
					else {
						setSystemDocsScrapedMinCount(e.target.value)
					}
				}
				if (data === 'System Response Time') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setSystemResponseTime(roundedValue)}
						else 
						{
							setSystemResponseTime('')
						}
					}
					else {
						setSystemResponseTime(e.target.value)
					}
				}
				if (data === 'Curation Routing Method') {
					if (id !== 'curationRouting') {
						if (e.value === 'Level') {
							setIsCountryVisible(true)
							setCurationMethod(e)
							setIsCountryDropdownVisible(true)
						}
						if (e.value !== 'Level') {
							setIsCountryVisible(false)
							setCurationMethod(e)
							setIsCountryDropdownVisible(false)
							// getCurationGroupValueAdmin(newArr)
							setCurationRoutingValues('')
							setCountryDropdownDefaultValue([])
						}
					}
					if (id === 'curationRouting') {
						setCurationRoutingValues(e)
					}
					// setCurationMethod(e)
				}
				if (data === 'Minimum Answers') {
					if (!Number.isInteger(e.target.value)) {
						const roundedValue = Math.round(e.target.value);
						if(roundedValue > 0)
						{
						setMinAcceptableAnswers(roundedValue)}
						else 
						{
							setMinAcceptableAnswers('')
						}
					}
					// else {
					// 	setMinAcceptableAnswers(e.target.value)
					// }
				}
				if (data === 'Re-routing Interval') {
					if (id === 'reroutingIntervalCountryDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue <= 365) {
								setReroutingCountryDays(roundedValue)
							}
							if (roundedValue > 365) {
								setReroutingCountryDays(365)
							}
						}
						if(e.target.value < 0)
						{
							setReroutingCountryDays(0)
						}
						// if (!Number.isInteger(e.target.value)) {
						// 	setUpdatedArrayRecordsRoutingIntervals((prev) => prev.map((item, index) => index === 0 ? { ...item, timeoutPeriod: e.target.value } : item))
						// 	console.log(updatedArrayRecordsRoutingIntervals,'check 123 and 456')
						// }
					}
					if (id === 'reroutingIntervalCountryHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue <= 23) {
								setReroutingCountryHours([])
								setReroutingCountryHours(roundedValue)
							}
							if (roundedValue > 23) {
								setReroutingCountryHours(23)
							}
						}
						else {
							setReroutingCountryHours(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingCountryHours(0)
						}
					}
					if (id === 'reroutingIntervalCountryMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue <= 59) {
								setReroutingCountryMinutes([])
								setReroutingCountryMinutes(roundedValue)
							}
							if (roundedValue > 59) {
								setReroutingCountryMinutes(59)
							}
						}
						else {
							setReroutingCountryMinutes(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingCountryMinutes(0)
						}
					}
					if (id === 'reroutingIntervalRegionDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							// setReroutingCountryDaysRegion(roundedValue)
							if (roundedValue > 365) {
								setReroutingCountryDaysRegion(365)
							}
							if (roundedValue <= 365) {
								setReroutingCountryDaysRegion([])
								setReroutingCountryDaysRegion(roundedValue)
							}
						}
						else {
							setReroutingCountryDaysRegion(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingCountryDaysRegion(0)
						}
					}
					if (id === 'reroutingIntervalRegionHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setReroutingCountryHoursRegion(23)
							}
							if (roundedValue <= 23) {
								setReroutingCountryHoursRegion([])
								setReroutingCountryHoursRegion(roundedValue)
							}
						}
						else {
							setReroutingCountryHoursRegion(e.target.value)
						}
						if (e.target.value < 0) {
							setReroutingCountryHoursRegion(0)
						}
					}
					if (id === 'reroutingIntervalRegionMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setReroutingCountryMinutesRegion(59)
							}
							if (roundedValue <= 59) {
								setReroutingCountryMinutesRegion(roundedValue)
							}
						}
						else {
							setReroutingCountryMinutesRegion(e.target.value)
						}
						if (e.target.value < 0) {
							setReroutingCountryMinutesRegion(0)
						}
					}
					if (id === 'reroutingIntervalGlobalDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 365) {
								setReroutingDaysGlobal(365)
							}
							if (roundedValue <= 365) {
								setReroutingDaysGlobal([])
								setReroutingDaysGlobal(roundedValue)
							}
						}
						else {
							setReroutingDaysGlobal(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingDaysGlobal(0)
						}
					}
					if (id === 'reroutingIntervalGlobalHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setReroutingHoursGlobal(23)
							}
							if (roundedValue <= 23) {
								setReroutingHoursGlobal([])
								setReroutingHoursGlobal(roundedValue)
							}
						}
						else {
							setReroutingHoursGlobal(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingHoursGlobal('')
						}
					}
					if (id === 'reroutingIntervalGlobalMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setReroutingGlobalMinutes(59)
							}
							if (roundedValue <= 59) {
								setReroutingGlobalMinutes([])
								setReroutingGlobalMinutes(roundedValue)
							}
						}
						else {
							setReroutingGlobalMinutes(e.target.value)
						}
						if(e.target.value < 0)
						{
							setReroutingGlobalMinutes('')
						}
					}
				}
				if (data === 'Abort Period') {
					if (id === 'abortPeriodCountryDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 365) {
								setAbortPeriodCountryDays(365)
							}
							if (roundedValue <= 365) {
								setAbortPeriodCountryDays(roundedValue)
							}
						}
						else {
							setAbortPeriodCountryDays(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodCountryDays(0)
						}
					}
					if (id === 'abortPeriodCountryHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setAbortPeriodCountryHours(23)
							}
							if (roundedValue <= 23) {
								setAbortPeriodCountryHours(roundedValue)
							}
						}
						else {
							setAbortPeriodCountryHours(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodCountryHours(0)
						}
					}
					if (id === 'abortPeriodCountryMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setAbortPeriodCountryMinutes(59)
							}
							if (roundedValue <= 59) {
								setAbortPeriodCountryMinutes(roundedValue)
							}
						}
						else {
							setAbortPeriodCountryMinutes(e.target.value)
						}
						if (e.target.value < 0) {
							setAbortPeriodCountryMinutes(0)
						}
					}
					if (id === 'abortPeriodRegionDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setAbortPeriodRegionDays(365)
							}
							if (roundedValue <= 365) {
								setAbortPeriodRegionDays(roundedValue)
							}
						}
						else {
							setAbortPeriodRegionDays(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodRegionDays(0)
						}
					}
					if (id === 'abortPeriodRegionHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setAbortPeriodRegionHours(23)
							}
							if (roundedValue <= 23) {
								setAbortPeriodRegionHours(roundedValue)
							}
						}
						else {
							setAbortPeriodRegionHours(e.target.value)
						}
						if (e.target.value < 0) {
							setAbortPeriodRegionHours(0)
						}
					}
					if (id === 'abortPeriodRegionMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setAbortPeriodRegionMinutes(23)
							}
							if (roundedValue <= 59) {
								setAbortPeriodRegionMinutes(roundedValue)
							}
						}
						else {
							setAbortPeriodRegionMinutes(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodRegionMinutes(0)
						}
					}
					if (id === 'abortPeriodGlobalDays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 365) {
								setAbortPeriodGlobalDays(365)
							}
							if (roundedValue <= 365) {
								setAbortPeriodGlobalDays(roundedValue)
							}
						}
						else {
							setAbortPeriodGlobalDays(e.target.value)
						}
						if (e.target.value < 0) {
							setAbortPeriodGlobalDays(0)
						}
					}
					if (id === 'abortPeriodGlobalHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setAbortPeriodGlobalHours(365)
							}
							if (roundedValue <= 23) {
								setAbortPeriodGlobalHours(roundedValue)
							}
						}
						else {
							setAbortPeriodGlobalHours(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodGlobalHours(0)
						}
					}
					if (id === 'abortPeriodGlobalMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setAbortPeriodGlobalMinutes(59)
							}
							if (roundedValue <= 59) {
								setAbortPeriodGlobalMinutes(roundedValue)
							}
						}
						else {
							setAbortPeriodGlobalMinutes(e.target.value)
						}
						if(e.target.value < 0)
						{
							setAbortPeriodGlobalMinutes(0)
						}
					}
				}
				if (data === 'Experts Assigned') {
					if (id === 'noOfExpertsCountry') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							setNoOfExpertsCountry(roundedValue)
						}
						else {
							setNoOfExpertsCountry(e.target.value)
						}
						if(e.target.value < 0)
						{
							setNoOfExpertsCountry(0);
						}
					}
					if (id === 'noOfExpertsRegion') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							setNoOfExpertsRegion(roundedValue)
						}
						else {
							setNoOfExpertsRegion(e.target.value)
						}
						if(e.target.value < 0)
						{
							setNoOfExpertsRegion(0);
						}
					}
					if (id === 'noOfExpertsGlobal') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							setNoOfExpertsGlobal(roundedValue)
						}
						else {
							setNoOfExpertsGlobal(e.target.value)
						}
						if(e.target.value < 0)
						{
							setNoOfExpertsGlobal(0);
						}
					}
				}
				if (data === 'Max Acceptance SLA') {
					if (id === 'maxSLADays') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 365) {
								setMaxSlaDays(365)
							}
							if (roundedValue <= 365) {
								setMaxSlaDays('')
								setMaxSlaDays(roundedValue)
							}
						}
						else {
							setMaxSlaDays(e.target.value)
						}
						if (e.target.value > 365) {
							setMaxSlaDays(365)
						}
						if (e.target.value < 0) {
							setMaxSlaDays(0)
						}
					}
					if (id === 'maxSLAHours') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 23) {
								setMaxSlaHours(23)
							}
							if (roundedValue <= 23) {
								setMaxSlaHours('')
								setMaxSlaHours(roundedValue)
							}
						}
						// else {
						// 	setMaxSlaHours(e.target.value)
						// }
						// if (e.target.value > 23) {
						// 	setMaxSlaHours(23)
						// }
						// if (e.target.value > 59) {
						// 	setMaxSlaMinutes(59)
						// }
						if (e.target.value < 0) {
							setMaxSlaHours(0)
						}
					}
					if (id === 'maxSLAMinutes') {
						if (!Number.isInteger(e.target.value)) {
							const roundedValue = Math.round(e.target.value);
							if (roundedValue > 59) {
								setMaxSlaMinutes(59)
							}
							if (roundedValue <= 59) {
								setMaxSlaMinutes('')
								setMaxSlaMinutes(roundedValue)
							}
						}
						else {
							setMaxSlaMinutes(e.target.value)
						}
						if(e.target.value < 0)
						{
							setMaxSlaMinutes(0)
						}
					}
				}
			})
	
			const onClickUpdate = (key) => {
				key = data;
				/* Code to handle all nine inputs for country, region and global for rerouting interval start */
				if (key === 'Re-routing Interval') {
					const updatedArray = updatedArrayRecordsRoutingIntervals.map((item, index) =>
						index === 0 ? { ...item, timeoutPeriod: (reroutingCountryDays * 1440) + (rereoutingCountryHours * 60) + rereoutingCountryMinutes }
							: index === 1 ? { ...item, timeoutPeriod: (reroutingCountryDaysRegion * 1440) + (reroutingCountryHoursRegion * 60) + reroutingCountryMinutesRegion }
								: index === 2 ? { ...item, timeoutPeriod: (reroutingDaysGlobal * 1440) + (reroutingHoursGlobal * 60) + reroutingGlobalMinutes } : null
					)
                    let arr2 = convertMinutesToDay(updatedArray[0]?.timeoutPeriod).split(',').map(Number)
                    setReroutingPeriod(arr2)
                    let arr3 = convertMinutesToDay(updatedArray[1]?.timeoutPeriod).split(',').map(Number)
                    setReroutingPeriodRegion(arr3)
                    let arr4 = convertMinutesToDay(updatedArray[2]?.timeoutPeriod).split(',').map(Number)
                    setReroutingPeriodGlobal(arr4)
					updateCurationRoutingLevels(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsRoutingIntervals(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getRoutingLevelsAdmin().then((res) => {
								if(res===undefined) return;
								if (res.data.data !== undefined || res.data.success) {
                                    // setUpdatedArrayRecordsRoutingIntervals(updatedArray)
									adminSettingsRoutingLevels(res.data.data)
								}
							})
						}
					})
				}
				/* Code to handle all nine inputs for country, region and global end */
				/* Code to handle all nine inputs for country,region and global for abort period start */
				if (key === 'Abort Period') {
					const updatedArray = updatedArrayRecordsRoutingIntervals.map((item, index) =>
						index === 0 ? { ...item, abortPeriod: (abortPeriodCountryDays * 1440) + (abortPeriodCountryHours * 60) + abortPeriodCountryMinutes }
							: index === 1 ? { ...item, abortPeriod: (abortPeriodRegionDays * 1440) + (abortPeriodRegionHours * 60) + abortPeriodRegionMinutes }
								: index === 2 ? { ...item, abortPeriod: (abortPeriodGlobalDays * 1440) + (abortPeriodGlobalHours * 60) + abortPeriodGlobalMinutes } : null
					)
                    let arr1 = convertMinutesToDay(updatedArray[0]?.abortPeriod).split(',').map(Number)
                    setAbortPeriodCountry(arr1)
                    let arr2 = convertMinutesToDay(updatedArray[1]?.abortPeriod).split(',').map(Number)
                    setAbortPeriodRegion(arr2)
                    let arr3 = convertMinutesToDay(updatedArray[2]?.abortPeriod).split(',').map(Number)
                    setAbortPeriodGlobal(arr3)
					updateCurationRoutingLevels(updatedArray).then((res) => {
						if(res===undefined) return;
						if (res.data.data !== undefined || res.data.success) {
                            setUpdatedArrayRecordsRoutingIntervals(updatedArray)
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getRoutingLevelsAdmin().then((res) => {
								if(res===undefined) return;
								if (res.data.data !== undefined || res.data.success) {
									adminSettingsRoutingLevels(res.data.data)
                                    // isLoadingAdminData(false)
								}
							})
						}
					})
				}
				if (key === 'Experts Assigned') {
					if ((noOfExpertsCountry >= 0 && noOfExpertsCountry <= MAX_VALUE) && (noOfExpertsRegion >= 0 && noOfExpertsRegion <= MAX_VALUE) && (noOfExpertsGlobal >= 0 && noOfExpertsGlobal <= MAX_VALUE)) {
						const updatedArray = updatedArrayRecordsRoutingIntervals.map((item, index) =>
							index === 0 ? { ...item, maxExpert: noOfExpertsCountry }
								: index === 1 ? { ...item, maxExpert: noOfExpertsRegion }
									: index === 2 ? { ...item, maxExpert: noOfExpertsGlobal }
										: null
						)
                        
						updateCurationRoutingLevels(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsRoutingIntervals(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getRoutingLevelsAdmin().then((res) => {
									if(res===undefined) return;
									if (res.data.data !== undefined || res.data.success) {
										adminSettingsRoutingLevels(res.data.data)
                                        // isLoadingAdminData(false)
									}
								})
							}
						})
					}
					if (!((noOfExpertsCountry >= 0 && noOfExpertsCountry <= MAX_VALUE) && (noOfExpertsRegion >= 0 && noOfExpertsRegion <= MAX_VALUE) && (noOfExpertsGlobal >= 0 && noOfExpertsGlobal <= MAX_VALUE))) {
						toast.error(successToastMessage(`Value should be greater than 0 and smaller than ${MAX_VALUE}.`))
					}
				}
                if(key === 'Max Acceptance SLA')
                {
                    const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
                        index === 0 ? { ...item, maxSla: (maxSlaDays * 1440) + (maxSlaHours * 60) + maxSlaMinutes } : item
                    )
                    let arr2 = convertMinutesToDay(updatedArray[0]?.maxSla).split(',').map(Number)
                    setMaxAcceptanceSLA(arr2)
                    updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
                        if (res.data.data !== undefined || res.data.success) {
                            toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
                            getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;
                                if (res.data.data !== undefined || res.data.success) {
                                    adminSettingsGroupInfo(res.data.data)
                                }
                            })
                        }
                    })
                }
				if (key === 'User Ranking') {
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userRankingsEnabled: userRankingVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;
								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if (key === 'Text Summarization') {
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, textSummarizationEnabled: textSummarizationVal } : item
					)
					// adminSettingsGroupInfo(updatedArray)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						//  setUpdatedArrayRecordsGroupInfo(updatedArray)
						}
					})
				}
				if (key === 'Search Count Email Records') {
					if(searchCountEmailRecordsVal > 0 && searchCountEmailRecordsVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, searchCountEmailRecords: searchCountEmailRecordsVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (searchCountEmailRecordsVal < 0) {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (!(searchCountEmailRecordsVal > 0 && searchCountEmailRecordsVal <= MAX_VALUE)) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
			}
				if (key === 'Search Count Doc Records') {
					if (searchCountDocRecordsVal > 0 && searchCountDocRecordsVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, searchCountDocRecords: searchCountDocRecordsVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					else if(searchCountDocRecordsVal < 0)
					{
						toast.error(successToastMessage(errorMessage.greaterThanZero),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
					if(!(searchCountDocRecordsVal > 0 && searchCountDocRecordsVal <= MAX_VALUE))
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Search Count Expert Records') {
					if (searchCountExpertRecordsVal > 0 && searchCountExpertRecordsVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, searchCountExpertRecords: searchCountExpertRecordsVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					else if (searchCountExpertRecordsVal < 0) {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					else if (!(searchCountExpertRecordsVal > 0 && searchCountExpertRecordsVal <= MAX_VALUE)) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Auto Suggest Count Expert Records') {
					if (autoSuggestCountRecordsVal > 0 && autoSuggestCountRecordsVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, autoSuggestCount: autoSuggestCountRecordsVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					else if (autoSuggestCountRecordsVal < 0)
					{
						toast.error(successToastMessage(errorMessage.greaterThanZero),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
					if(!(autoSuggestCountRecordsVal > 0 && autoSuggestCountRecordsVal <= MAX_VALUE))
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Urgent Question Timeout Period') {
					// if(timeoutPeriodUrgentVal > 0)
					if(timeoutPeriodUrgentVal > 0 && timeoutPeriodUrgentVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, timeoutPeriodUrgent: timeoutPeriodUrgentVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				else if(!(timeoutPeriodUrgentVal > 0 && timeoutPeriodUrgentVal <= MAX_VALUE))
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				else if(timeoutPeriodUrgentVal < 0)
					{
						toast.error(successToastMessage(errorMessage.greaterThanOrEqualToZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Unanswered Question Timeout Period') {
					if (unansweredQuestionsDaysVal > 0 && unansweredQuestionsDaysVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, unansweredQuestionsDays: unansweredQuestionsDaysVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if(unansweredQuestionsDaysVal < 0 || unansweredQuestionsDaysVal === '')
					{
						toast.error(successToastMessage(errorMessage.greaterThanZero),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Declined Answer Window') {
					if (declinedAnswerWindowVal > 0 && declinedAnswerWindowVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, threshold: declinedAnswerWindowVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if (declinedAnswerWindowVal < 0 || declinedAnswerWindowVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (declinedAnswerWindowVal >= MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Expert Curation Evergreen Window') {
					if (expertCurationEvergreen !== '' && expertCurationEvergreen <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, evergreenMonths: (expertCurationEvergreen * 12) } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if(expertCurationEvergreen === '')
					{
						toast.error(successToastMessage(errorMessage.greaterThanOrEqualToZero),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
					if (expertCurationEvergreen > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}		
				}
				if (key === 'Expert Answer Expiration') {
					if(expertAnswerExpirationVal > 0 && expertAnswerExpirationVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, expirationMonths: expertAnswerExpirationVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(expertAnswerExpirationVal < 0 || expertAnswerExpirationVal === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(expertAnswerExpirationVal > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'Seeker Curation Visiblity') {
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, seekerCurationVisibility: seekerCurationVisibilityVal } : item
					)
					// if (key === 'Text Summarization') {
					// 	const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
					// 		index === 0 ? { ...item, textSummarizationEnabled: textSummarizationVal } : item
					// 	)
					// 	updateAdminGroupInfo(updatedArray).then((res) => {
					// 		if (res.data.data !== undefined || res.data.success) {
					// 			toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
					// 			getGroupInfoAdmin().then((res) => {
					// 				if (res.data.data !== undefined || res.data.success) {
					// 					adminSettingsGroupInfo(res.data.data)
					// 				}
					// 			})
					// 		}
					// 	})
					// }
					// setUpdatedArrayRecordsGroupInfo(updatedArray)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if (key === 'User Searches') {
					if(userSearchesVal > 0 && userSearchesVal <= MAX_VALUE)
					{
					 const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userOverallSearches: userSearchesVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
						if (res.data.data !== undefined || res.data.success) {
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (userSearchesVal < 0 || userSearchesVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(userSearchesVal >= MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'User Knowledge Records Viewed') {
					if(userKnowledgeRecordsVal > 0 && userKnowledgeRecordsVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userKnowledgeRecordsViewed: userKnowledgeRecordsVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (userKnowledgeRecordsVal < 0 || userKnowledgeRecordsVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(userKnowledgeRecordsVal > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'User Question Submitted') {
					if(userQuestionsSubmittedVal > 0 && userQuestionsSubmittedVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userQuestionsSubmittedToExperts: userQuestionsSubmittedVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (userQuestionsSubmittedVal < 0 || userQuestionsSubmittedVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (userQuestionsSubmittedVal > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'User Knowledge Records Viewed MinCount') {
					if (userKnowledgeRecordsMinVal > 0 && userKnowledgeRecordsMinVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userKnowledgeRecordsViewedMinCount: userKnowledgeRecordsMinVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (userKnowledgeRecordsMinVal < 0 || userKnowledgeRecordsMinVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if ((userKnowledgeRecordsMinVal > MAX_VALUE)) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'User Overall Searches MinCount') {
					if (userOverallSearchesVal > 0 && userOverallSearchesVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, userOverallSearchesMinCount: userOverallSearchesVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if (userOverallSearchesVal < 0 || userOverallSearchesVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (userOverallSearchesVal > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'User Questions Submitted To Experts MinCount') {
					if(userQuestionsSubmittedMinVal > 0 && userQuestionsSubmittedMinVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, userQuestionsSubmittedToExpertsMinCount: userQuestionsSubmittedMinVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(userQuestionsSubmittedMinVal < 0 || userQuestionsSubmittedMinVal === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
					if (userQuestionsSubmittedMinVal > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
			}
				if (key === 'Overall Searches') {
					if (overallSearchesVal > 0 && overallSearchesVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, systemOverallSearches: overallSearchesVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
				}
				if(overallSearchesVal < 0 || overallSearchesVal === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if (overallSearchesVal > MAX_VALUE) {
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'Overall Knowledge Records Viewed') {
					if(overallKnowledgeRecordsViewedVal > 0 && overallKnowledgeRecordsViewedVal <=MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemKnowledgeRecordsViewed: overallKnowledgeRecordsViewedVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (overallKnowledgeRecordsViewedVal < 0 || overallKnowledgeRecordsViewedVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(!(overallKnowledgeRecordsViewedVal <=MAX_VALUE))
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Overall Questions Answered') {
					if(overallQuestionsAnsweredVal > 0 && overallQuestionsAnsweredVal <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemQuestionsAnswered: overallQuestionsAnsweredVal } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (overallQuestionsAnsweredVal < 0 || overallQuestionsAnsweredVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(overallQuestionsAnsweredVal > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Overall LoggedIn') {
					if(overallLoggedIn > 0 && overallLoggedIn <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemUserLogins: overallLoggedIn } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (overallLoggedIn === '' || overallLoggedIn < 0) {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(overallLoggedIn > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Overall Document Scraped') {
					if(docScrapped > 0 && docScrapped <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemDocsScraped: docScrapped } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (docScrapped < 0 || docScrapped === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (docScrapped > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Overall Likes') {
					if(overallLikes > 0 && overallLikes <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemLikes: overallLikes } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(overallLikes < 0 || overallLikes === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(overallLikes > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'Overall Key Terms') {
					if(keyTermViews > 0 && keyTermViews <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemTrendingKeyTermsViews: keyTermViews } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(keyTermViews < 0 || keyTermViews === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(keyTermViews > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'Overall Question View') {
					if(overallQuestionView > 0)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemQuestionsDocViewCount: overallQuestionView } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(overallQuestionView < 0 || overallQuestionView === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(overallQuestionView > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'Overall Knowledge Updates') {
					if(systemknowledgeUpdates > 0 && systemknowledgeUpdates <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemKnowledgeUpdates: systemknowledgeUpdates } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					if (systemknowledgeUpdates < 0 || systemknowledgeUpdates === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (systemknowledgeUpdates > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'System Knowledge Updates MinCount') {
					if(knowledgeUpdates > 0 && knowledgeUpdates <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemKnowledgeUpdatesMinCount: knowledgeUpdates } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(knowledgeUpdates <= 0 || knowledgeUpdates === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero), {
						position: toast.POSITION.TOP_RIGHT
					})
				}
				if (knowledgeUpdates > MAX_VALUE) {
					toast.error(successToastMessage(errorMessage.greaterThanLimit), {
						position: toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'System Knowledge Records Viewed MinCount') {
					if (knowledgeRecordsMinVal > 0 && knowledgeRecordsMinVal <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
							index === 0 ? { ...item, systemKnowledgeRecordsViewedMinCount: knowledgeRecordsMinVal } : item
						)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if (knowledgeRecordsMinVal < 0 || knowledgeRecordsMinVal === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (knowledgeRecordsMinVal > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'System Likes MinCount') {
					if(systemLikesMinCount > 0 && systemLikesMinCount <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemLikesMinCount: systemLikesMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					else if (systemLikesMinCount < 0 || systemLikesMinCount === '') {
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					else if (systemLikesMinCount > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})	
					}
				}
				if (key === 'System Overall Searches MinCount') {
					if(systemOverallSearches > 0 && systemOverallSearches <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemOverallSearchesMinCount: systemOverallSearches } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				else if( systemOverallSearches < 0 || systemOverallSearches === '')
					{
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					else if (systemOverallSearches > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'System Questions Answered MinCount') {
					if (systemQuestionsMinCount > 0 && systemQuestionsMinCount <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemQuestionsAnsweredMinCount: systemQuestionsMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(systemQuestionsMinCount < 0 || systemQuestionsMinCount === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(systemQuestionsMinCount > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'System Questions DocView MinCount') {
					if(systemQuestionsDocViewMinCount > 0 && systemQuestionsDocViewMinCount <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemQuestionsDocViewMinCount: systemQuestionsDocViewMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
						if (res.data.data !== undefined || res.data.success) {
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				if(systemQuestionsDocViewMinCount < 0 || systemQuestionsDocViewMinCount === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(systemQuestionsDocViewMinCount > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit), {
						position: toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'System Trending KeyTerms Views MinCount') {
					if(systemTrendingKeyTermsViewsMinCount > 0 && systemTrendingKeyTermsViewsMinCount <= MAX_VALUE )
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemTrendingKeyTermsViewsMinCount: systemTrendingKeyTermsViewsMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				else if(systemTrendingKeyTermsViewsMinCount < 0 || systemTrendingKeyTermsViewsMinCount === '' )
				{	
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
					if (systemTrendingKeyTermsViewsMinCount > MAX_VALUE) {
						toast.error(successToastMessage(errorMessage.greaterThanLimit), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'System User Logins MinCount') {
					if(systemUserLoginsMinCount > 0 && systemUserLoginsMinCount <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemUserLoginsMinCount: systemUserLoginsMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
					else if (
						systemUserLoginsMinCount < 0 || systemUserLoginsMinCount === '') {
							toast.error(successToastMessage(errorMessage.greaterThanZero),{
								position:toast.POSITION.TOP_RIGHT
							})
					}
					if(systemUserLoginsMinCount > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'System Docs Scraped MinCount') {
					if(systemDocsScrapedMinCount > 0 && systemDocsScrapedMinCount <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemDocsScrapedMinCount: systemDocsScrapedMinCount } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				else if( systemDocsScrapedMinCount < 0 || systemDocsScrapedMinCount === '')
				{
					toast.error(successToastMessage(errorMessage.greaterThanZero),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				if(systemDocsScrapedMinCount > MAX_VALUE)
				{
					toast.error(successToastMessage(errorMessage.greaterThanLimit),{
						position:toast.POSITION.TOP_RIGHT
					})
				}
				}
				if (key === 'System Response Time') {
					if(systemResponseTime > 0 && systemResponseTime <= MAX_VALUE)
					{
					const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, systemResponseTime: systemResponseTime } : item
					)
					updateAdminGroupInfo(updatedArray).then((res) => {
						if(res===undefined) return;
                        setUpdatedArrayRecordsGroupInfo(updatedArray)
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							getGroupInfoAdmin().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									adminSettingsGroupInfo(res.data.data)
								}
							})
						}
					})
				}
				else if(systemResponseTime < 0 || systemResponseTime === '')
					{
						toast.error(successToastMessage(errorMessage.greaterThanZero), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if(systemResponseTime > MAX_VALUE)
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Minimum Answers') {
					if (getMinAcceptableAnswers > 0 && getMinAcceptableAnswers <= MAX_VALUE) {
						const updatedArray = updatedArrayRecordsGroupInfo.map((item, index) =>
						index === 0 ? { ...item, minAcceptableAnswer: getMinAcceptableAnswers } : item
					)
						updateAdminGroupInfo(updatedArray).then((res) => {
							if(res===undefined) return;
                            setUpdatedArrayRecordsGroupInfo(updatedArray)
							if (res.data.data !== undefined || res.data.success) {
								toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
								getGroupInfoAdmin().then((res) => {
									if(res===undefined) return;

									if (res.data.data !== undefined || res.data.success) {
										adminSettingsGroupInfo(res.data.data)
									}
								})
							}
						})
					}
					if (getMinAcceptableAnswers < 0) {
						toast.error(successToastMessage("Value should be greater than 0."), {
							position: toast.POSITION.TOP_RIGHT
						})
					}
					if (!(getMinAcceptableAnswers > 0 && getMinAcceptableAnswers <= MAX_VALUE))
					{
						toast.error(successToastMessage(errorMessage.greaterThanLimit),{
							position:toast.POSITION.TOP_RIGHT
						})
					}
				}
				if (key === 'Curation Routing Method') {
					let payload = {
						...((curationMethod.label === undefined && curationRouting.value !== undefined) &&
						{
							startPointId: adminSettingReducer?.curationRoutingValueByGroup[0].id,
							startPointValue: curationRouting.startPointValue,
						}),
						...((curationMethod.label === undefined && curationRouting.value === undefined)
							&& {
							startPointId: adminSettingReducer?.curationRoutingValueByGroup[0].id,
							startPointValue: adminSettingReducer?.curationRoutingValueByGroup[0].startPointValue,
						})
						,
						// ...((curationMethod.id !== undefined || curationMethod.label !== 'Level') ? { startPointId: curationMethod.id } : { startPointId: adminSettingReducer?.curationRoutingValueByGroup[0].startPointId }),
						...((curationMethod.id !== undefined && curationMethod.label !== 'Level') && {
							startPointId: curationMethod.id, 
						}),
						// ...((curationRouting.label !== undefined) &&
						// {
						// 	// startPointId: curationMethod === null ? adminSettingReducer?.curationRoutingValueByGroup[0].startPointId : curationMethod.id,
						// 	startPointId: curationMethod.id,
						// 	startPointValue: curationRouting.startPointValue,
						// }
						// )
						...((curationMethod.label === 'Level' && curationRouting.value !== undefined) && 
						{
							startPointId:curationMethod.id,
							startPointValue:curationRouting.startPointValue,
						})
					}
					updateCurationPoint(payload).then((res) => {
						if(res===undefined) return;
						if (res.data.data !== undefined || res.data.success) {
							toast.success(successToastMessage(res.data.message), { position: toast.POSITION.TOP_RIGHT })
							// getGroupInfoAdmin().then((res) => {
							// 	if (res.data.data !== undefined || res.data.success) {
							// 		adminSettingsGroupInfo(res.data.data)
							// 	}
							// })
							getCurationRoutingAdminValuesByGroups().then((res) => {
								if(res===undefined) return;

								if (res.data.data !== undefined || res.data.success) {
									getCurationGroupValueAdmin(res.data.data)
								}
							})
						}
					})
	
				}
			}
	
			const TabMemoized = React.memo(() => {
				return (
					<>
						<VizHeader type={6}></VizHeader>
						<Tabs items={items} />
					</>
				)
			})
	
			const ValueContainer = ({ children, ...props }) => {
				let [values, input] = children;
				if (Array.isArray(values)) {
					const plural = values.length === 1 ? "" : "s";
					values = `${values.length} selected`;
				}
			
				return (
					<components.ValueContainer {...props}>
						{values}
						{input}
					</components.ValueContainer>
				);
			};

			const memoizedTabs = React.useMemo(() => <MyTabsComponent tabData={items} tabIndexKey={tabIndexKey} onChangeTabsForReRouting={onChangeTabsForReRouting} data={data} />, [items]);
			const memoizedTabsForAbortPeriod = React.useMemo(()=> <MyTabsComponent tabData={itemsAbortPeriod} tabIndexKey={tabIndexKeyAbortPeriod} onChangeTabsForRerouting={onChangeTabsForAbortPeriod} data={data}  />)
			return (
				<>
					{
						data === 'Minimum Answers' &&
						(
							<>
								{/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<Input type="number" min={1} onChange={onChangeCheckbox} addonAfter={"Answers"} value={getMinAcceptableAnswers} />
									<Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button>
								</div> */}
								<Grid container columnGap={2}>
									<Grid item lg={7}>
										<Input type="number" min={1} onChange={onChangeCheckbox} addonAfter={"Answers"} value={getMinAcceptableAnswers} onFocus = {(e)=>handleOnWeel(e)} />
									</Grid>
									<Grid item lg={2}>
										{/* <Button onClick={onClickUpdate} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
										<VizButton size={2} type={"Primary"} onClick={onClickUpdate}>
											Update
										</VizButton>
									</Grid>
								</Grid>
							</>
						)
					}
					{
						data === "Curation Routing Method" &&
						(
							<>
								<VizHeader type={6}>Select Routing Method:</VizHeader>
								<Grid container columnGap={isCountryDropdownVisible ? 1 : 6}>
									<Grid item lg={isCountryDropdownVisible ? 3 : 6} xl={isCountryDropdownVisible ? 4 : 6} xs={5} sm={5} md={12}>
										<Select isSearchable={false} value={curationMethod} defaultValue={curationMethod.length > 0 ? curationMethod : ""} placeholder={curationMethod.length > 0 ? "" : "Select Level"}  styles={customStyles} onChange={onChangeCheckbox} options={adminSettingReducer?.curationRoutingOptions} />
									</Grid>
									{(isCountryDropdownVisible)
										&&
										<Grid item xl={4} lg={4} xs={5} sm={5} md={12}>
											<Select isSearchable={false} styles={customStyles} options={curationRoutingValues}
												placeholder="Select Level"
												// defaultValue={
												// 	((countryDropdownDefaultValue[0]?.description === 'Level' 
												// 		)
												// 		&&
												// 		adminSettingReducer?.curationRoutingValueByGroup[0].startPointValue === 3)
												// 		? curationRoutingValues[2]
												// 		:
												// 		adminSettingReducer?.curationRoutingValueByGroup[0].startPointValue === 2
												// 			? curationRoutingValues[1]
												// 			:
												// 			adminSettingReducer?.curationRoutingValueByGroup[0].startPointValue === 1
												// 				? curationRoutingValues[0]
												// 				: ""
												// }
												defaultValue={
													(countryDropdownDefaultValue[0]?.description === 'Level')
														&&
														(countryDropdownDefaultValue[0]?.startPointValue === 1
														?
														curationRoutingValues[0]
														:
														countryDropdownDefaultValue[0]?.startPointValue === 2
															?
															curationRoutingValues[1]
															: curationRoutingValues[2])
												}
												onChange={(selectedOption) => onChangeCheckbox(selectedOption, "curationRouting")}
											/>
											{(curationMethod.value === 'Level' && curationRouting.value === undefined) &&
												<span style={{ color: 'red', fontSize: '12px' }}>Please select level.</span>}
										</Grid>
									}
									<Grid item lg={2} xs={2} sm={2} md={2}>
										{/* <Button onClick={onClickUpdate} style={{
											backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)', minHeight: '29px',
											opacity: (curationMethod.value === 'Level' && curationRouting.value === undefined)
												&& 0.4
	
										}}
											disabled={curationMethod.value === 'Level' && curationRouting.value === undefined ? true : false}
										>Update</Button> */}
										{(curationMethod.value === 'Level' && curationRouting.value === undefined) ? <VizButton size={2} type={'Disabled'} onClick={onClickUpdate}>Update</VizButton> : <VizButton onClick={onClickUpdate} size={2} type={'Primary'}>Update</VizButton> }
										{/* <VizButton size={2} type={"Primary"} onClick={(data, id) => onClickUpdate(data, id)}>
											Update
										</VizButton> */}
									</Grid>
								</Grid>
							</>
						)
					}
					{
						data === "User Ranking" &&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', columnGap: '20px' }}>
									<VizHeader type={6}>{data}{" "}
										<Checkbox defaultChecked={userRankingVal} onChange={onChangeCheckbox} />
									</VizHeader>
									{/* <Button onClick={onClickUpdate} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Text Summarization" &&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', columnGap: '20px' }}>
									<VizHeader type={6}>{data}{" "}
										<Checkbox defaultChecked={textSummarizationVal} onChange={onChangeCheckbox} />
									</VizHeader>
									{/* <Button onClick={onClickUpdate} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Search Count Email Records"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Count:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={searchCountEmailRecordsVal} type="number" min={1} addonAfter="Records" onFocus = {(e)=>handleOnWeel(e)}/>
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Search Count Doc Records"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Count:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={searchCountDocRecordsVal} type="number" min={1} addonAfter="Records" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Search Count Expert Records"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Count:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={searchCountExpertRecordsVal} type="number" min={1} addonAfter="Records" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Auto Suggest Count Expert Records"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Count:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={autoSuggestCountRecordsVal} type="number" min={1} addonAfter="Records" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)'}}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Urgent Question Timeout Period"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Duration:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={timeoutPeriodUrgentVal} type="number" min={0} addonAfter="Minutes" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Unanswered Question Timeout Period"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Duration:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={unansweredQuestionsDaysVal} type="number" min={0} addonAfter="Days" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === "Declined Answer Window"
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Duration:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={declinedAnswerWindowVal} type="number" min={0} addonAfter="Minutes" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === 'Expert Curation Evergreen Window'
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Duration:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={expertCurationEvergreen} type="number" min={1} addonAfter="Years" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === 'Expert Answer Expiration'
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>Duration:</VizHeader>
									<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={expertAnswerExpirationVal} type="number" min={1} addonAfter="Months" onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === 'Seeker Curation Visiblity' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>{data}{" "}
									<Checkbox defaultChecked={seekerCurationVisibilityVal} onChange={onChangeCheckbox} />
								</VizHeader>
								{/* <Button onClick={onClickUpdate} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Searches' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={userSearchesVal} type="number" min={1} addonAfter="Days" onFocus = {(e)=>handleOnWeel(e)}/>
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Knowledge Records Viewed' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={userKnowledgeRecordsVal} type="number" min={1} addonAfter="Days" onFocus = {(e)=>handleOnWeel(e)}/>
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Question Submitted' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} value={userQuestionsSubmittedVal} type="number" min={1} addonAfter="Days" onFocus = {(e)=>handleOnWeel(e)}/>
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Knowledge Records Viewed MinCount' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={userKnowledgeRecordsMinVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Overall Searches MinCount' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={userOverallSearchesVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'User Questions Submitted To Experts MinCount' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={userQuestionsSubmittedMinVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Searches' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallSearchesVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Knowledge Records Viewed' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallKnowledgeRecordsViewedVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
	
						)
					}
					{
						data === 'Overall Questions Answered' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallQuestionsAnsweredVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall LoggedIn' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallLoggedIn} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Document Scraped' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={docScrapped} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Likes' &&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallLikes} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Key Terms'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={keyTermViews} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Question View'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={overallQuestionView} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Overall Knowledge Updates'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>Duration:{" "}
								</VizHeader>
								<Input style={{ paddingLeft: '5px', paddingRight: '5px' }} onChange={onChangeCheckbox} addonAfter="Days" value={systemknowledgeUpdates} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Knowledge Records Viewed MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={knowledgeRecordsMinVal} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Knowledge Updates MinCount'
						&&
						(
							<>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<VizHeader type={6}>MinCount:{" "}
									</VizHeader>
									<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={knowledgeUpdates} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
									{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
									<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
								</div>
							</>
						)
					}
					{
						data === 'System Likes MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemLikesMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Overall Searches MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemOverallSearches} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Questions Answered MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemQuestionsMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Questions DocView MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemQuestionsDocViewMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Trending KeyTerms Views MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemTrendingKeyTermsViewsMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System User Logins MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemUserLoginsMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Docs Scraped MinCount'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemDocsScrapedMinCount} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'System Response Time'
						&&
						(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<VizHeader type={6}>MinCount:{" "}
								</VizHeader>
								<Input style={{ marginLeft: '5px', marginRight: '5px' }} onChange={onChangeCheckbox} value={systemResponseTime} type="number" min={1} onFocus = {(e)=>handleOnWeel(e)} />
								{/* <Button onClick={onClickUpdate} style={{ marginLeft: '5px', backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
								<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
							</div>
						)
					}
					{
						data === 'Re-routing Interval' &&
						(
							<>
								<VizHeader type={6}>Time Out Period:</VizHeader>
								<Tabs  defaultActiveKey={localStorage.getItem('tabKeyRerouting')} items={items} onChange={onChangeTabsForReRouting} />
								{/* <TabMemoized /> */}
								{/* {memoizedTabs} */}
							</>
						)
					}
					{
						data === 'Abort Period' &&
						(
							<>
								<VizHeader type={6}>Abort Period:</VizHeader>
								<Tabs defaultActiveKey={localStorage.getItem('tabKeyAbortPeriod')} items={itemsAbortPeriod} onChange={onChangeTabsForAbortPeriod} />
								{/* {memoizedTabsForAbortPeriod} */}
							</>
						)
					}
					{
						data === 'Experts Assigned' &&
						(
							<>
								<VizHeader type={6}>Max Experts:</VizHeader>
								<Tabs defaultActiveKey={localStorage.getItem('tabKeyForExpertsAssigned')} items={expertsAssignedItems} onChange={onChangeTabsForExpertsAssigned} />
							</>
						)
					}
					{
						data === 'Max Acceptance SLA' &&
						(
							<>
								<Grid container columnGap={2}>
									<Grid item lg={2}>
										<VizHeader type={6}>Days:</VizHeader>
										<Input min={0} max={365} value={maxSlaDays} defaultValue={maxSlaDays} onChange={(e) => onChangeCheckbox(e, "maxSLADays")} type="number" onFocus = {(e)=>handleOnWeel(e)}></Input>
									</Grid>
									<Grid item lg={2}>
										<VizHeader type={6}>Hours:</VizHeader>
										<Input min={0} max={23} value={maxSlaHours} defaultValue={maxSlaHours} type="number" onChange={(e) => onChangeCheckbox(e, "maxSLAHours")} onFocus = {(e)=>handleOnWeel(e)}></Input>
									</Grid>
									<Grid item lg={2}>
										<VizHeader type={6}>Minutes:</VizHeader>
										<Input min={0} max={59} value={maxSlaMinutes} defaultValue={maxSlaMinutes} type="number" onChange={(e) => onChangeCheckbox(e, "maxSLAMinutes")} onFocus = {(e)=>handleOnWeel(e)}></Input>
									</Grid>
									<Grid item lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',paddingTop:'12px' }}>
										<div>
										{/* <Button onClick={onClickUpdate} style={{ backgroundColor: 'var(--viz_primary_button_color)', color: '#fff', border: '1px solid var(--viz_primary_button_color)' }}>Update</Button> */}
										<VizButton size={2} type={'Primary'} onClick={onClickUpdate}>Update</VizButton>
										</div>
									</Grid>
								</Grid>
							</>
						)
					}
				</>
			)
		}

		const MyTabsComponent = React.memo(({ tabData, onChangeTabsForReRouting,tabIndexKey,data }) => (
			data === 'Re-routing Interval' &&<Tabs defaultActiveKey={localStorage.getItem('tabKeyRerouting')} items={tabData} onChange={onChangeTabsForReRouting} />,
			data === 'Abort Period' && <Tabs defaultActiveKey={localStorage.getItem('tabKeyAbortPeriod')} items={tabData} onChange={onChangeTabsForReRouting} />
		))
		return (
			<>
				<div style={{ marginTop: '12px' }}>
					<VizHeader type={5}>{props.data.text}
					</VizHeader>
					<span style={{
						color: '#000000',
						fontSize: '14px',
						fontWeight: 200
					}}>{" "}({props.data.subText})</span>
					{/* <div><VizHeader type={6}>{props.data.text}:</VizHeader></div> */}
					{/* <Tabs defaultActiveKey="1" items={noOfExpertItems} onChange={onChange} style={{ width: '50' }} /> */}
					<Grid container>
						<Grid item xs={7} md={12} lg={((props.data.text !== 'Curation Routing Method') || (props.data.text !== 'Experts Assigned')) ? 4.2 : 12} xl={(props.data.text !== 'Curation Routing Method' || props.data.text !== 'Experts Assigned') ? 4.2 : 12}>
							<InputComponent data={props.data.text} />
						</Grid>
					</Grid>
				</div>
				<Divider style={{ color: 'lightgray' }} /> 
			</>
		)
	}



	return (
		<>
			<Box>
				<Grid container>
					{/* <Grid xs={12} lg={1} sm={12} md={12} alignItems="center"> */}
					<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => onClickBackButton()}>
						<ArrowBackIcon style={
							{ color: 'var(--viz_primary_button_color)', marginRight: '2px' }} />
						<VizHeader type={4} isBold={true}>Back</VizHeader>
					</div>
					{/* </Grid> */}
				</Grid>
				<Card>					
					{/* {
						adminSettingReducer?.isLoading &&
						<>
						<Flex gap="middle" vertical>
						<Spin spinning={adminSettingReducer?.isLoading} />
						</Flex>
						</>
						} */}
					{/* {adminSettingReducer?.settingId === 1 && <RoutingSettings />} */}
					{adminSettingReducer?.settingId === 1 && (
						settingListAdmin["Expert Routing"].map((obj, ind) => {
							return <SettingsListBox data={obj} />
						})
					)}
					{adminSettingReducer?.settingId === 2 &&
						(
							settingListAdmin["Search Results"].map((obj, ind) => {
								return <SettingsListBox data={obj} />
							})
						)
					}
					{
						adminSettingReducer?.settingId === 3 &&
						(
							settingListAdmin["Expert Settings"].map((obj, ind) => {
								return <SettingsListBox data={obj} />
							})
						)
					}
					{
						adminSettingReducer?.settingId === 4 &&
						(
							settingListAdmin["Knowledge Curation"].map((obj, ind) => {
								return <SettingsListBox data={obj} />
							})
						)
					}
					{
						adminSettingReducer?.settingId === 5 &&
						(
							<>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<SettingsIcon sx={{ marginRight: '3px',fontSize:'24px' }} /><VizHeader type={4} isBold={true}>{settingListAdmin["Seeker Home"]["User Level"].key}</VizHeader>
								</div>
								{settingListAdmin["Seeker Home"]["User Level"].data.map((obj) => {
									return (
										<SettingsListBox data={obj} />
									)
								})}
							</>
						)
					}
					{
						adminSettingReducer?.settingId === 5 &&
						(
							<>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<SettingsIcon sx={{ marginRight: '3px',fontSize:'24px' }} /><VizHeader type={4} isBold={true}>{settingListAdmin["Seeker Home"]["Total Users"].key}</VizHeader>
								</div>
								{settingListAdmin["Seeker Home"]["Total Users"].data.map((obj) => {
									return <SettingsListBox data={obj} />
								})}
							</>
						)
					}
					{
						adminSettingReducer?.settingId === 5 &&
						(
							<>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<SettingsIcon sx={{ marginRight: '3px',fontSize:'24px' }} /><VizHeader type={4} isBold={true}>{settingListAdmin["Seeker Home"]["System Level"].key}</VizHeader>
								</div>
								{settingListAdmin["Seeker Home"]["System Level"].data.map((obj) => {
									return <SettingsListBox data={obj} />
								})}
							</>
						)
					}
{
						adminSettingReducer?.settingId === 6 &&
						(
							<>
							<AgenticSettingComponent/>
							</>
						)
					}

				</Card>
			</Box>
		</>
	)
}